



import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import ModuleModal from './ModuleModal';

const ModuleList = () => {
    const [modules, setModules] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedModuleId, setSelectedModuleId] = useState(null);
    const [selectedModuleData, setSelectedModuleData] = useState(null);
    const didFetchRef = useRef(false);

    useEffect(() => {
        if (!didFetchRef.current) {
            fetchModules();
            didFetchRef.current = true;
        }
    }, []);

    const fetchModules = async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;

            const response = await axios.get('http://localhost:8000/api/modules', {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            setModules(response.data.module);
        } catch (error) {
            console.error('Error fetching modules:', error);
        }
    };

    const addModule = async (newModule) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;

            const response = await axios.post('http://localhost:8000/api/modules', newModule, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            const createdModule = response.data.module[0];
            setModules(prevModules => [...prevModules, createdModule]);
        } catch (error) {
            console.error('Error adding module:', error);
        }
    };

    const editModule = async (moduleId, updatedData) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;

            const response = await axios.put(`http://localhost:8000/api/modules/${moduleId}`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            const updatedModule = response.data.module[0];

            // Update the module in the state
            setModules(prevModules =>
                prevModules.map(module => (module.id === updatedModule.id ? updatedModule : module))
            );
        } catch (error) {
            console.error('Error updating module:', error);
        }
    };

    const deleteModule = async (id) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;

            await axios.delete(`http://localhost:8000/api/modules/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            setModules(modules.filter(module => module.id !== id));
        } catch (error) {
            console.error('Error deleting module:', error);
        }
    };

    const handleShowModal = (moduleId = null) => {
        if (moduleId) {
            const moduleToEdit = modules.find(module => module.id === moduleId);
            if (moduleToEdit) {
                setSelectedModuleData(moduleToEdit);
            } else {
                console.error('Module to edit not found');
            }
        } else {
            setSelectedModuleData(null); // Reset for creating a new module
        }
        setSelectedModuleId(moduleId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedModuleId(null);
        setSelectedModuleData(null); // Reset selected module data when modal is closed
    };

    return (
        <div><br/>
            <h2 className="text-center">Modules</h2>
            <div className="d-flex justify-content-end mb-3" style={{ paddingRight: '45px' }}>
                <button className="btn btn-light" onClick={() => handleShowModal()}>
                    <FaPlus />
                </button>
            </div>

            <table className="table table-bordered" style={{ width: '75%', margin: '0 auto' }}>
                <thead className="text-center">
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody className="text-center">
                    {modules.length > 0 ? (
                        modules.map((module,index) => (
                            <tr key={module.id}>
                                <td>{index+1}</td>
                                <td>{module.name}</td>
                                <td>
                                    <FaEdit className="text-warning me-3" onClick={() => handleShowModal(module.id)} />
                                    <FaTrash className="text-danger" onClick={() => deleteModule(module.id)} />
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3">No modules available</td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ModuleModal
                show={showModal}
                handleClose={handleCloseModal}
                moduleId={selectedModuleId}
                moduleData={selectedModuleData} // Pass the selected module data for editing
                addModule={addModule} // Pass addModule function
                editModule={editModule} // Pass editModule function
            />
        </div>
    );
};

export default ModuleList;











